import { useLocation } from "preact-iso";
import "./Header.scss";
import EzCouponsLogo from "../../assets/ezcoupons-black.png";
import { useState } from "preact/hooks";

export function Header() {
  const { url } = useLocation();

  const handleSearch = (e) => {
    if (e.key === "Enter") {
      window.location.href = '/search/' + e.target.value;
    }
  }

  return (
    <header>
      <div class="header-logo-nav">
        <a href="/">
          <img src={EzCouponsLogo} alt="logo"/>
        </a>
        <nav>
          <a href="/" class={url == "/" && "active"}>
            Home
          </a>
          <a href="/categories" class={url == "/categories" && "active"}>
            Categories
          </a>
        </nav>
      </div>
      <div class="d-flex align-center">
        <div class="header-search">
          <input type="search" placeholder="Search" onKeyDown={handleSearch}/>
        </div>
        <div>
          <a href="/login">Login</a>
          {/* <a href="/signup">Signup</a> */}
        </div>
      </div>
    </header>
  );
}
